import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ProdSheet01Actions, { ProdSheet01Types } from '../Stores/ProdSheet01/Actions';

const getAppStore = state => state.app;

export function* prodSheet01FetchProdSheet01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(ProdSheet01Actions.prodSheet01FetchProdSheet01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `prodSheet/indexProcess/PROD_SHEET_01/${app.curDivisionId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        ProdSheet01Actions.prodSheet01FetchProdSheet01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdSheet01Actions.prodSheet01FetchProdSheet01Loading(false));
  }
}

export function* prodSheet01CreateProdSheet01({ hdrIds }) {
  try {
    yield put(ProdSheet01Actions.prodSheet01CreateProdSheet01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `prodSheet/createProcess/PROD_SHEET_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(ProdSheet01Actions.prodSheet01CreateProdSheet01Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(ProdSheet01Actions.prodSheet01CreateProdSheet01Loading(false));
  }
}

export function* prodSheet01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodIssDetail/update/${hdrId}`));
}

export function* prodSheet01NewDocument() {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/prodIssDetail/create/${app.curDivisionId}`));
}

export const saga = [
  takeLatest(ProdSheet01Types.PROD_SHEET01_FETCH_PROD_SHEET01, prodSheet01FetchProdSheet01),
  takeLatest(ProdSheet01Types.PROD_SHEET01_CREATE_PROD_SHEET01, prodSheet01CreateProdSheet01),
  takeLatest(ProdSheet01Types.PROD_SHEET01_GO_TO_DOCUMENT, prodSheet01GoToDocument),
  takeLatest(ProdSheet01Types.PROD_SHEET01_NEW_DOCUMENT, prodSheet01NewDocument)
];
